import { StoreState } from '../store-interfaces';

export const selectEnv = (state: StoreState) => state.env;
export const selectWidgetPlatformsMap = (state: StoreState) =>
  state.env.widgetsByPlatforms;

export const globalJavascriptBaseUrlSelector = (state: StoreState) =>
  state.env.globalJavascriptBaseUrl;
